import React from 'react';
import Link from 'next/link';
import Block from '@views/components/block/Block';
import { Col } from 'react-bootstrap';
import styled from 'styled-components';
import WelcomeIcon from '@views/static/welcome.svg';

const Header = styled.h2`
  font-size: 2rem;
`;
const Text = styled.p`
  font-size: 1.25rem;
`;

export const EmptyState = () => (
  <Block isSection isFixedHeight isFlexCenter className="mb-4">
    <Col xs={8} md={5} lg={4} className="ml-md-4 mt-4 mb-4 pt-4 pt-md-0">
      <WelcomeIcon />
    </Col>
    <Col xs={12} md={5} lg={6}>
      <div className="not-found mt-4">
        <Header className="not-found__title not-found__title--v2">
          Giỏ hàng trống
        </Header>
        <Text className="not-found__text not-found__text--v2">
          Không có sản phẩm nào trong giỏ hàng của bạn.
        </Text>
      </div>
      <div className="mb-4">
        <Link href="/">
          <a className="text-info">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="fill-info"
              width="4.5"
              height="6"
              viewBox="0 0 4.5 6"
            >
              <path
                id="Polygon_52"
                d="M3 0l3 4.5H0z"
                transform="rotate(-90 3 3)"
              />
            </svg>
            <span className="ml-2">Tiếp tục mua sắm</span>
          </a>
        </Link>
      </div>
    </Col>
  </Block>
);

export default EmptyState;
